import { render } from "./HeroImg.vue?vue&type=template&id=3fbc283e"
import script from "./HeroImg.vue?vue&type=script&lang=js"
export * from "./HeroImg.vue?vue&type=script&lang=js"

import "./HeroImg.vue?vue&type=style&index=0&id=3fbc283e&lang=scss"

import exportComponent from "/Users/abiinteriors/Documents/WorkSpace/abi-landing-page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__